import { render, staticRenderFns } from "./czVip.vue?vue&type=template&id=28493f27&scoped=true&"
import script from "./czVip.vue?vue&type=script&lang=js&"
export * from "./czVip.vue?vue&type=script&lang=js&"
import style0 from "./czVip.vue?vue&type=style&index=0&id=28493f27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28493f27",
  null
  
)

export default component.exports